import { useEffect, useState } from "react";

import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import logger from "../../../utils/logger";
import { deliveryStatesMapping } from "./DeliverystateModel";
import { Link } from "react-router-dom";

export const DeliveryActions = ({ status, row, handleModal, alert, handleAlertContent, memberShip, handleMemberId, actionPack }) => {

    logger.debug('status: ', status)
    let DeliveryMock = actionPack




    // const findProperty = (array) => {
    //     const element = array.find(({ state }) => {
    //         return state === status
    //     })
    //     logger.debug('element: ', element)

    //     return element
    // }

    //! Funcion para concretar acciones sobre un usuario
    // const actionsOnUser = (e, rowData, type, title, btnTitle, verb, apiAction,) => {

    const actionsOnUser = (e, row, obj) => {

        logger.debug('actionsOnUser e: ', e.currentTarget.dataset.base)
        logger.debug('actionsOnUser row: ', row?.member.id)


        e.stopPropagation() //👉 evita que dispare el click de la fila si hay

        //👉 activar un modal de interrogación

        if (e.currentTarget.dataset.base === 'visibility' && memberShip) {
            handleMemberId(row.member?.id)
            handleModal('info')
            return
        }


        if (alert) {
            handleModal('alert')


        }

        // const email = rowData?.member?.email

        // const newRow = { ...rowData, email, type: type, title: title, btnTitle: btnTitle, urlSegment: "Delivery", verb, apiAction }



        logger.debug('Actions row: ', { ...row })
        // handleAlertContent(newRow)

        const newRow = { id: row?.id, ...obj, email: row?.member?.email }
        logger.info('new row: ', newRow)
        handleAlertContent(newRow)

    };

    const actionsIcons = (obj, row) => {

        logger.info('row en ActionOnUser: ', row)
        logger.debug('row en ActionOnUser objetc: ', obj)
        // console.log('row en ActionOnUser objetc: ', obj)
        // logger.debug('obj.buttons: ', obj.buttons.length > 0)

        return (


            <OverlayTrigger

                placement="top"
                overlay={<Tooltip id={`tooltip-${obj?.verb}`}>{obj?.verb}</Tooltip>}
            >


                {obj?.key === 5 ?

                    <Link
                        to={``}
                        className={`btn toTooltip-style`}
                        data-base='visibility'
                        onClick={(e) => actionsOnUser(e, row, obj)}
                    >
                        <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj?.icon}</span>
                    </Link>

                    :
                    <button
                        className={`btn toTooltip-style`}
                        onClick={(e) => actionsOnUser(e, row, obj)}>
                        <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj?.icon}</span>
                    </button>

                }



            </OverlayTrigger>


        )

    };

    const renderActionButtons = (status, row) => {
        //? status proveniente de la API
        switch (status) {
            case 'Pending':

                return <>
                    {actionsIcons(DeliveryMock.Contactar, row)}
                    {actionsIcons(DeliveryMock.Enviar, row)}
                    {actionsIcons(DeliveryMock.Ver, row)}


                </>

            case 'Reached':
                return <>


                    {actionsIcons(DeliveryMock.Enviar, row)}
                    {actionsIcons(DeliveryMock.Ver, row)}


                </>
            case 'Sent':
                return <>


                    {actionsIcons(DeliveryMock.Ver, row)}


                </>

            case 'AddressNotFound':
                return <>


                    {actionsIcons(DeliveryMock.Enviar, row)}
                    {actionsIcons(DeliveryMock.Ver, row)}

                </>

            case 'Cancelled':
                return <>


                    {/* {actionsIcons(DeliveryMock.Enviar, row)} */}
                    {actionsIcons(DeliveryMock.Ver, row)}

                </>


            case 'Returned':
                return <>


                    {actionsIcons(DeliveryMock.Enviar, row)}
                    {actionsIcons(DeliveryMock.Ver, row)}

                </>
            default:
                break;
        }
        // return <>

        //     {actionsIcons(findProperty(deliveryStatesMapping), row)}
        //     {/* {actionsIcons(actionMock.Ver, row)} */}


        // </>
    };



    return (
        <>{renderActionButtons(status, row)}</>
    )
}


